// RestTypeComp.jsx
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { DynamicKeyValueInput } from "./DynamicKeyValueInput";

const RestTypeComp = ({ control, path, rule }) => {
  console.log("====rule", rule);
  return (
    <Box
      mt={4}
      p={3}
      bg="orange.50"
      borderRadius="md"
      border="1px solid"
      borderColor="orange.200"
    >
      <Text fontWeight="medium" color="orange.700" mb={2}>
        🌐 REST Configuration
      </Text>

      <SimpleGrid columns={2} spacing={4}>
        {/* API URL */}
        <FormControl mb={3}>
          <FormLabel>Api URL</FormLabel>
          <Controller
            control={control}
            name={`${path}.URL`}
            render={({ field }) => (
              <Input
                {...field}
                borderRadius="md"
                borderColor="gray.300"
                bg="white"
                placeholder="https://example.com/api"
              />
            )}
          />
        </FormControl>

        {/* Processor */}
        <FormControl mb={3}>
          <FormLabel>Processor (optional)</FormLabel>
          <Controller
            control={control}
            name={`${path}.PROCESSOR`}
            render={({ field }) => (
              <Input
                {...field}
                borderRadius="md"
                borderColor="gray.300"
                bg="white"
                placeholder="teams_notification"
              />
            )}
          />
        </FormControl>
      </SimpleGrid>

      {/* URL PARAMS + HEADERS */}
      <SimpleGrid mt={4} columns={2} spacing={5}>
        <Box>
          <FormControl>
            <FormLabel>URL PARAMS</FormLabel>
            <DynamicKeyValueInput
              control={control}
              name={`${path}.URL_PARAMS`}
              placeholderKey="Header Name"
              placeholderValue="Header Value or REF:Field"
            />
          </FormControl>
        </Box>

        <Box>
          <FormLabel fontWeight="semibold">Headers</FormLabel>
          <DynamicKeyValueInput
            control={control}
            name={`${path}.HEADERS`}
            placeholderKey="Header Name"
            placeholderValue="Header Value or REF:Field"
          />
        </Box>
      </SimpleGrid>

      {/* BODY */}
      <Box mt={4}>
        <FormLabel fontWeight="semibold">Body Fields</FormLabel>
        <DynamicKeyValueInput
          control={control}
          name={`${path}.BODY`}
          placeholderKey="Field Name"
          placeholderValue="Value or REF:Field"
        />
      </Box>
    </Box>
  );
};

export default RestTypeComp;
